<template lang='pug'>
  div
    transition(name="fade")
      router-view#app
        template(slot='svg-icons')
          svg-sprite
</template>

<script>
import { AmplifyEventBus } from 'aws-amplify-vue';
import { mapGetters, mapActions } from 'vuex';
import SvgSprite from '@/components/SvgSprite.vue';

// import MainApp from './models/app';

export default {
  name: 'App',
  components: { SvgSprite },
  data() {
    return {
      appObj: '',
      appInit: false,
    };
  },
  computed: {
    // ...mapGetters('shared', ['loading']),
    ...mapGetters('users', ['me', 'isMeSignedIn', 'isSuperAdmin']),
  },
  created() {
    this.setMe();
    AmplifyEventBus.$on('authState', (info) => {
      if (info === 'signedOut') {
        this.$router.push('/auth');
        this.resetMe();
      }
      if (info === 'signedIn' || info === 'confirmReset') {
        this.setMe();
        if (this.$route.path !== '/') {
          this.$router.push('/');
        }
      } else {
        this.resetMe();
      }
    });
  },

  methods: {
    ...mapActions('users', ['setMe', 'resetMe', 'setMeIsSignedIn']),
  },
};
</script>

<style lang='scss'>
@import "./assets/scss/plugins";
@import "./assets/scss/main";
</style>
